import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Images/logos/hvp_logo_mobile.webp")